import { NETWORK } from '@shared/utils/constant'
import { alchemyRpcEndpoint } from '@shared/wallet'
import { Web3Client } from '@/app/services/web3/Web3Client'

export * from './utils'
export * from './contracts'

export const web3Client = new Web3Client({
  network: NETWORK,
  rpc: alchemyRpcEndpoint
})
